'use strict';

var withPrecision = require('../../common/internal/withPrecision');

function createRoundingFunction(fn) {
  return function(n, precision) {
    return precision ? withPrecision(n, precision, fn) : fn(n);
  };
}

module.exports = createRoundingFunction;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/internal/createRoundingFunction.js
// module id = 122
// module chunks = 0